export const GET_APPLESMS = "GET_APPLESMS";
export const GET_APPLESMS_SUCCESS = "GET_APPLESMS_SUCCESS";
export const GET_APPLESMS_FAIL = "GET_APPLESMS_FAIL";

export const ADD_APPLESMS_SUCCESS = "ADD_APPLESMS_SUCCESS";
export const ADD_APPLESMS_FAIL = "ADD_APPLESMS_FAIL";
export const UPDATE_APPLESMS_SUCCESS = "UPDATE_APPLESMS_SUCCESS";
export const DELETE_APPLESMS_SUCCESS = "DELETE_APPLESMS_SUCCESS";
